<template>
  <section class="section_streetwear">
    <div class="section_streetwear--bg">
      <div class="section_streetwear--scene">
        <img
          src="https://ik.imagekit.io/intervi/case_streetwear/1_ckXO65w8r.png"
          data-src="https://ik.imagekit.io/intervi/case_streetwear/1_ckXO65w8r.png"
          id="scene"
          alt
        />
        <div class="meteor-wrapper">
          <img
            src="https://ik.imagekit.io/intervi/case_streetwear/1-asteroid_S3Y5SmKrSu.png"
            data-src="https://ik.imagekit.io/intervi/case_streetwear/1-asteroid_S3Y5SmKrSu.png"
            class="meteor"
            id="meteor-1"
            alt
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    moveAsteroid() {
      $(document).mousemove(function(event) {
        $(".meteor-wrapper").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 0.5, {
            x: xPos * -30,
            y: yPos * -30,
            ease: Power1.easeOut
          });
        });
      });
    },
    moveScene() {
      $(document).mousemove(function(event) {
        $("#scene").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 0.5, {
            x: xPos * 30,
            y: yPos * 30,
            ease: Power1.easeOut
          });
        });
      });
    }
  },
  mounted() {
    this.moveAsteroid();
    this.moveScene();
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/inner-components/ComponentStreetwear.vue